;(function () {
    const BLOCKED_AFTER = 1500

    function showPoster(video) {
        if (video.dataset.posterShown) return
        const src = video.getAttribute("poster")
        if (!src) return
        video.dataset.posterShown = "true"

        const img = document.createElement("img")
        img.src = src

        img.className = video.className
        img.alt = video.getAttribute("aria-label") || ""
        img.decoding = "async"

        video.after(img)
        video.pause()

        video.style.display = "none"
    }

    function attempt(video) {
        if (video.hasAttribute("muted")) video.muted = true
        video.playsInline = true

        const played = video.play()
        if (played && typeof played.catch === "function")
            played.catch(() => showPoster(video))

        setTimeout(() => {
            if (video.paused) showPoster(video)
        }, BLOCKED_AFTER)
    }

    function init() {
        const videos = [...document.querySelectorAll("video[autoplay]")].filter(
            (video) => video.getClientRects().length
        )
        if (!videos.length) return

        if (!("IntersectionObserver" in window)) {
            videos.forEach(attempt)
            return
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return
                    observer.unobserve(entry.target)
                    attempt(entry.target)
                })
            },
            { rootMargin: "10% 0px" }
        )
        videos.forEach((video) => observer.observe(video))
    }

    document.addEventListener("DOMContentLoaded", init)
})()
